export const layoutCorrectionDraftKey = 'anjabom.layout-correction-draft.v1';
export function readLayoutCorrectionDraft(storage: Pick<Storage, 'getItem'>): string | null {
  const raw = storage.getItem(layoutCorrectionDraftKey);
  if (raw === null) return null;
  const value: unknown = JSON.parse(raw);
  if (!value || typeof value !== 'object' || !('text' in value) || typeof value.text !== 'string') throw new Error('Invalid correction draft');
  return value.text;
}
export function saveLayoutCorrectionDraft(storage: Pick<Storage, 'setItem' | 'getItem'>, text: string): void {
  storage.setItem(layoutCorrectionDraftKey, JSON.stringify({ text }));
  if (readLayoutCorrectionDraft(storage) !== text) throw new Error('Correction draft read-back failed');
}
